/**
 * แปลง id จาก URL (useParams) เป็นตัวเลขแบบเข้ม — BUG-S2283-001
 *
 * เดิมหลายหน้าใช้ parseInt(id) ซึ่งรับ "487abc" → 487 และ "1e3" → 1 (เปิดข้อมูลผิดตัวเงียบ ๆ)
 * และ "abc" → NaN ที่ถูกยิงเป็น GET /x/NaN แล้วโชว์ข้อความ validator ดิบ ("ต้องเป็นตัวเลข")
 * คืน null เมื่อ id ไม่ใช่จำนวนเต็มบวกล้วน → หน้าต้องไม่ยิง API และแสดง "ไม่พบ…" เอง
 */
export function parseRouteId(id: string | undefined | null): number | null {
  if (!id || !/^[1-9]\d{0,15}$/.test(id)) return null;
  const n = Number(id);
  return Number.isSafeInteger(n) ? n : null;
}
